import memoize from 'fast-memoize';

/**
 * @param {Date} date a date to convert to yyyy-MM-dd string,
 * if null today will be used
 * @returns {string} yyyy-MM-dd
 */
export const getDay = (date = new Date()) => {
  return date.toISOString().slice(0, 10);
};

/**
 * @param {string|Date} date
 * @returns {Boolean}
 *
 * @example
 * isEmptyDate('2019-01-01')
 * // false
 *
 * @example
 * isEmptyDate(new Date())
 * // false
 *
 * @example
 * isEmptyDate('')
 * // true
 */
export const isEmptyDate = date => {
  return date == null || date.toString().trim() === '';
};

const parseISOLocalTemp = s => {
  if (isEmptyDate(s)) {
    return null;
  }

  var b = s.split(/\D/);
  if (b.length > 3) {
    return new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5]);
  } else {
    return new Date(b[0], b[1] - 1, b[2]);
  }
};

/**
 * @param {string} s an ISO 8001 format date and time string
 * with all components or just the day
 * @returns {Date} Date instance from parsing the string. May be NaN.
 *
 * @example
 * parseISOLocal('2015-11-24T19:40:00')
 * @example
 * parseISOLocal('2015-11-24')
 */
export const parseISOLocal = memoize(parseISOLocalTemp);
